import React, { useEffect } from "react";
import { Card, Descriptions, Layout, Radio, Table, Tag } from "antd";
import { observer } from "mobx-react";
import { Store } from "../../store/Store";
import { EditOutlined } from "@ant-design/icons";
import { Link, useHistory, useLocation } from "react-router-dom";
import { FrTypes2 } from "../../common/Fr";
import { Utils } from "../../common/Utils";
import { FundraisingDlg } from "./components/FundraisingDlg";
import moment from "moment";
import { RegionFilterBar } from "../../components/filter/RegionFilterBar";
import { SortOrder } from "antd/lib/table/interface";

export const Fundraisers = observer(() => {
  const store = Store.fundsStore;
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const onEdit = (m) => {
    store.fundEdit.edit(m.id);
  };

  const onPending = (pending) => {
    const query = new URLSearchParams({ pending });
    history.push({
      search: query.toString(),
    });
  };

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter) => {
    console.log("sorter", sorter);
    store.sortedInfo = sorter;
    store.refresh();
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Fundraiser Name",
      dataIndex: "name",
      key: "name.keyword",
      width: "15%",
      sorter: (a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()),
      render: (t, r) => (
        <div>
          <Link to={`/fundraisers/${r.id}`}>{t}</Link>
          {r.shareCode && <Tag>{r.shareCode}</Tag>}
        </div>
      ),
      sortOrder: store.sortedInfo.columnKey === "name.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 90,
      sorter: (a, b) => a.type - b.type,
      render: (t) => FrTypes2[t],
      sortOrder: store.sortedInfo.columnKey === "type" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "School",
      dataIndex: ["org", "name"],
      width: "15%",
      // sorter: (a, b) => a.org.name.toLocaleLowerCase().localeCompare(b.org.name.toLocaleLowerCase()),
      key: "school",
    },
    {
      title: "Organizer",
      dataIndex: ["funOrg", "name"],
      width: "15%",
      // sorter: (a, b) => a.funOrg.name.toLocaleLowerCase().localeCompare(b.funOrg.name.toLocaleLowerCase()),
      key: "org",
    },
    {
      title: "Duration",
      key: "start",
      width: "15%",
      sorter: (a, b) => moment(a.start).valueOf() - moment(b.start).valueOf(),
      render: (_, r) => Utils.timeDuration(r),
      sortOrder: store.sortedInfo.columnKey === "start" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Target",
      dataIndex: "target",
      className: "col-money",
      key: "target",
      width: 50,
      sorter: (a, b) => a.target - b.target,
      render: (t) => Utils.fmtMoney(t),
      sortOrder: store.sortedInfo.columnKey === "target" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      key: "state",
      width: "8%",
      sortOrder: store.sortedInfo.columnKey === "state" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Description",
      dataIndex: "description",
      width: "30%",
      key: "description",
    },
    {
      title: "",
      key: "opt",
      render: (t, r) => (Store.isDivision ? null : <EditOutlined onClick={() => onEdit(r)} />),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <div>
        <Radio.Group size="large" value={store.filter.pending} onChange={(e) => onPending(e.target.value)}>
          <Radio.Button value={true}>Pending Decision</Radio.Button>
          <Radio.Button value={false}>History</Radio.Button>
        </Radio.Group>
      </div>
      <RegionFilterBar store={store} actionsSpan={16}></RegionFilterBar>

      <Card size="small">
        <Descriptions title="Summary">
          <Descriptions.Item label="Number of Fundraiser"> {store.data.total || 0} </Descriptions.Item>
          <Descriptions.Item label="Average Approval Time"> </Descriptions.Item>
        </Descriptions>
        <Table
          size="small"
          onChange={onChange}
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          rowKey="id"
          columns={columns}
          dataSource={store.data.items}
        />
        <FundraisingDlg></FundraisingDlg>
      </Card>
    </Layout.Content>
  );
});
